export function OpenAccessIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.20169 6.88893C4.20169 4.92525 5.80273 3.33337 7.7777 3.33337C9.75267 3.33337 11.3537 4.92525 11.3537 6.88893C11.3537 8.85261 9.75267 10.4445 7.7777 10.4445C5.80273 10.4445 4.20169 8.85261 4.20169 6.88893ZM7.7777 5.11115C6.79021 5.11115 5.9897 5.90709 5.9897 6.88893C5.9897 7.87077 6.79021 8.66671 7.7777 8.66671C8.76518 8.66671 9.5657 7.87077 9.5657 6.88893C9.5657 5.90709 8.76518 5.11115 7.7777 5.11115Z"
        fill="currentColor"
        fillOpacity="0.54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.7777 11.3334C6.26009 11.3334 5.16576 11.9036 4.44117 12.724C3.74245 13.5151 3.43985 14.4768 3.34437 15.2231C3.23575 16.072 3.94154 16.6667 4.6487 16.6667H10.9067C11.6139 16.6667 12.3196 16.072 12.211 15.2231C12.1155 14.4768 11.8129 13.5151 11.1142 12.724C10.3896 11.9036 9.29531 11.3334 7.7777 11.3334ZM9.77071 13.8971C10.0291 14.1897 10.2049 14.5413 10.3144 14.8889H5.24101C5.35045 14.5413 5.52625 14.1897 5.78468 13.8971C6.1591 13.4731 6.75814 13.1112 7.7777 13.1112C8.79725 13.1112 9.39629 13.4731 9.77071 13.8971Z"
        fill="currentColor"
        fillOpacity="0.54"
      />
      <path
        d="M10.7407 10.126C11.192 10.3305 11.6937 10.4445 12.2221 10.4445C14.1971 10.4445 15.7981 8.85261 15.7981 6.88893C15.7981 4.92525 14.1971 3.33337 12.2221 3.33337C11.6937 3.33337 11.192 3.44734 10.7407 3.6519C11.9763 4.21185 12.8352 5.45066 12.8352 6.88893C12.8352 8.3272 11.9763 9.56601 10.7407 10.126Z"
        fill="currentColor"
        fillOpacity="0.54"
      />
      <path
        d="M12.3882 16.6667H15.3511C16.0583 16.6667 16.7641 16.072 16.6555 15.2231C16.56 14.4768 16.2574 13.5151 15.5587 12.724C14.8341 11.9036 13.7398 11.3334 12.2221 11.3334C11.6739 11.3334 11.1809 11.4078 10.7407 11.5415C11.5192 11.778 12.1329 12.2 12.5957 12.724C13.2944 13.5151 13.597 14.4768 13.6925 15.2231C13.8011 16.072 13.0953 16.6667 12.3882 16.6667Z"
        fill="currentColor"
        fillOpacity="0.54"
      />
    </svg>
  );
}
